module.exports = __webpack_public_path__ + "static/media/fund.274ca8ed.svg";